import { breakpoints, Button, Heading, PageBlock, Stack, Text, vars } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { device } from '@eti/utils';
import { Confetti } from '@phosphor-icons/react';
import { Helmet } from 'react-helmet';
import { routes } from '../../../constants/routesAndApisConstants';
import { eventTypes, useGetBlue } from '../../../utils/useGetBlue';
import ReceiptMobileAppBanner from '../../receipt/components/ReceiptMobileAppBanner';

const blockStyles = css`
  align-items: center;
  height: 100%;
`;

const mobileAppBannerStyle = css`
  border-block: 1px solid ${vars.colors.divider};
  margin: 0 auto;
  padding: 16px 10px;

  @media (min-width: ${breakpoints._768}) {
    max-width: 750px;
    padding: 16px 15px;
  }

  @media (min-width: ${breakpoints._970}) {
    max-width: 970px;
  }

  @media (min-width: ${breakpoints._1024}) {
    max-width: none;
  }
`;

const stackStyles = css`
  text-align: center;
`;

const iconStyles = css`
  height: 4rem;
  width: 4rem;
`;

const buttonStyles = css`
  width: fit-content;
`;

const ContinueAfterDownload = () => {
  const { t } = useTranslation();

  return (
    <Stack
      align="center"
      as="section"
      className={stackStyles}
      data-testid="mobile-app-download-page-after-download-section"
      spacing={16}
    >
      <Confetti
        aria-hidden
        className={iconStyles}
        color={`${vars.colors.decoration.primary}`}
        data-testid="confetti-icon"
        weight="light"
      />
      <Heading level={1}>{t('Order.DownloadApp.AfterDownload.Title')}</Heading>
      <Text as="p" variant="16">
        {t('Order.DownloadApp.AfterDownload.Text')}
      </Text>
      <Button as="a" className={buttonStyles} href={routes.START} size="large" variant="primary">
        {t('Order.DownloadApp.Continue.Text')}
      </Button>
    </Stack>
  );
};

const MobileAppDownloadPage = () => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const appStoreLink = p('Order.DownloadApp.AppStoreLink');
  const playStoreLink = p('Order.DownloadApp.PlayStoreLink');
  const isMobileDevice = device.openAppStoreLink(appStoreLink, playStoreLink);

  useGetBlue(eventTypes.VISIT);

  return (
    <>
      <Helmet title={t('PageTitle.rf.mobile-app-download.action')} />
      <PageBlock className={blockStyles} data-testid="mobile-app-download-page" withPaddingY>
        {isMobileDevice ? (
          <ContinueAfterDownload />
        ) : (
          <ReceiptMobileAppBanner className={mobileAppBannerStyle} />
        )}
      </PageBlock>
    </>
  );
};

export default MobileAppDownloadPage;
